import { useId } from 'react';

type Props = {
  src: string;
  alt: string;
};

/**
 * Cadre organique (silhouette fluide + traits blancs décoratifs)
 * pour la bannière « Organisation pédagogique ».
 */
export default function PublicProgrammeBannerFrame({ src, alt }: Props) {
  const rawId = useId().replace(/:/g, '');
  const clipId = `organic-mask-path-${rawId}`;
  const clipUrl = `url(#${clipId})`;

  return (
    <div className="public-programme-banner-frame" data-purpose="frame-wrapper">
      <div
        className="public-programme-banner-frame__shadow"
        data-purpose="decorative-shadow"
        style={{ clipPath: clipUrl, WebkitClipPath: clipUrl }}
        aria-hidden
      />

      <div
        className="public-programme-banner-frame__mask"
        data-purpose="masked-image-container"
        style={{ clipPath: clipUrl, WebkitClipPath: clipUrl }}
      >
        <img src={src} alt={alt} loading="lazy" decoding="async" />
      </div>

      <svg
        className="public-programme-banner-frame__decor"
        viewBox="0 0 500 500"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <defs>
          <clipPath id={clipId} clipPathUnits="objectBoundingBox">
            <path d="M0.47,0.027 C0.655,-0.012 0.817,0.063 0.906,0.222 C0.963,0.324 0.963,0.441 0.941,0.554 C0.916,0.678 0.865,0.793 0.771,0.879 C0.677,0.966 0.547,1 0.407,0.985 C0.276,0.971 0.166,0.887 0.106,0.773 C0.046,0.659 0.036,0.52 0.088,0.402 C0.138,0.291 0.244,0.198 0.354,0.135 C0.39,0.114 0.428,0.098 0.47,0.027" />
          </clipPath>
        </defs>
        <path
          d="M235,13.5 C327.5,-6 408.5,31.5 453,111 C481.5,162 481.5,220.5 470.5,277 C458,339 432.5,396.5 385.5,439.5 C338.5,483 273.5,500 203.5,492.5 C138,485.5 83,443.5 53,386.5 C23,329.5 18,260 44,201 C69,145.5 122,99 177,67.5 C195,57 214,49 235,13.5"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="5"
        />
        <path
          d="M200,80 Q250,50 350,75"
          fill="none"
          stroke="rgba(255,255,255,0.7)"
          strokeLinecap="round"
          strokeWidth="3"
        />
        <path
          d="M80,300 Q120,350 150,420"
          fill="none"
          stroke="white"
          strokeLinecap="round"
          strokeWidth="3.5"
        />
      </svg>
    </div>
  );
}
